module.exports = __webpack_public_path__ + "static/media/pfsbi.b7079aaa.png";